// App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Appointment from './pages/Appointment';
import PageWrapper from './components/PageWrapper';

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <PageWrapper
                component={Home}
                title="Your Family Dentist in Topi, Swabi"
                description="Zia Dental Care – professional dental services in Topi, Swabi. General dentistry, implants, orthodontics, root canals & cosmetic procedures. Book your appointment today!"
                keywords="dentist Topi, dental clinic Swabi, Zia Dental Care, family dentist KPK, dental implants Swabi, best dentist Swabi"
              />
            }
          />
          <Route
            path="/about"
            element={
              <PageWrapper
                component={About}
                title="About Us – Meet Our Expert Dental Team"
                description="Meet the experienced dental professionals at Zia Dental Care in Topi, Swabi. Over 30 years of expertise in implants, orthodontics, oral surgery & more."
                keywords="Zia Dental team, Dr Abid Zia, dentist Topi Swabi, experienced dental surgeons KPK"
              />
            }
          />
          <Route
            path="/services"
            element={
              <PageWrapper
                component={Services}
                title="Dental Services – Implants, Orthodontics, Root Canals & More"
                description="Comprehensive dental services in Topi, Swabi – general dentistry, implants, orthodontics, root canal therapy, oral surgery, periodontal treatment & cosmetic dentistry."
                keywords="dental services Swabi, dental implants Topi, orthodontics KPK, root canal Swabi, oral surgery, cosmetic dentistry Pakistan"
              />
            }
          />
          <Route
            path="/contact"
            element={
              <PageWrapper
                component={Contact}
                title="Contact Us – Zia Dental Care, Topi, Swabi"
                description="Contact Zia Dental Care in Topi, Swabi. Call +92 314 7776565 or visit us. Open Mon-Thu & Sat-Sun, 10:30 AM – 8:00 PM."
                keywords="Zia Dental contact, dental clinic phone Swabi, dentist location Topi, dental clinic hours"
              />
            }
          />
          <Route
            path="/appointment"
            element={
              <PageWrapper
                component={Appointment}
                title="Book Appointment – Schedule Your Dental Visit Online"
                description="Book your dental appointment at Zia Dental Care in Topi, Swabi. Easy online booking with our experienced dental professionals. Call +92 314 7776565."
                keywords="book dentist appointment Swabi, online dental booking Topi, schedule dental visit KPK, dental consultation Pakistan"
              />
            }
          />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};

export default App;